import useMutation from "src/hooks/useMutation";

function useWTCreateExport(id) {
  return useMutation({
    path: `/api/v1/warehouse-transfers/${id}/transfer-details/export`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useWTCreateExport;
